import { render, staticRenderFns } from "./ArrowLink.vue?vue&type=template&id=676d696b&scoped=true"
import script from "./ArrowLink.vue?vue&type=script&lang=js"
export * from "./ArrowLink.vue?vue&type=script&lang=js"
import style0 from "./ArrowLink.vue?vue&type=style&index=0&id=676d696b&prod&lang=postcss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "676d696b",
  null
  
)

export default component.exports